import React, { useState } from 'react';
import './HeatWarningBanner.css';

// Versionierter Key: Banner gilt für dieses Hitze-Wochenende. Nach Ablauf
// einfach Komponente aus App.tsx entfernen oder Key hochzählen.
const DISMISS_KEY = 'heat-warning-dismissed-2026-06-27';

// Zeitfenster: Banner ist nur bis Montag 00:00 (lokale Zeit) sichtbar und
// blendet sich danach automatisch aus – kein zweites Deploy zum Entfernen nötig.
const VISIBLE_UNTIL = new Date('2026-06-29T00:00:00');

const MESSAGE =
  'Hitzewarnung am Wochenende: Wegen der hohen Temperaturen können einzelne Events ' +
  'kurzfristig abgesagt oder Startzeiten vorverlegt werden. Bitte prüft zusätzlich ' +
  'die Webseiten der Veranstalter, bevor ihr losfahrt.';

// Eine "Set" füllt die Breite; der Track rendert zwei identische Sets,
// die Animation verschiebt um -50% für einen nahtlosen Loop.
const REPEAT_PER_SET = 3;

const HeatWarningBanner: React.FC = () => {
  const [dismissed, setDismissed] = useState(() => {
    try {
      return localStorage.getItem(DISMISS_KEY) === 'true';
    } catch {
      return false;
    }
  });

  if (dismissed) return null;
  if (new Date() >= VISIBLE_UNTIL) return null;

  const handleDismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, 'true');
    } catch {
      /* localStorage nicht verfügbar – Banner trotzdem schließen */
    }
    setDismissed(true);
  };

  const items = Array.from({ length: REPEAT_PER_SET * 2 }, (_, i) => (
    <span className="heat-banner__item" key={i}>
      <span aria-hidden="true">🌡️</span>
      <span>{MESSAGE}</span>
      <span className="heat-banner__dot" aria-hidden="true">•</span>
    </span>
  ));

  return (
    <div className="heat-banner" role="alert">
      <div className="heat-banner__viewport">
        <div className="heat-banner__track">{items}</div>
      </div>
      <button
        type="button"
        className="heat-banner__close"
        onClick={handleDismiss}
        aria-label="Hinweis schließen"
      >
        ×
      </button>
    </div>
  );
};

export default HeatWarningBanner;
